import { Label } from "components/label"
import { CollapsibleSection } from "../../../../../../components/collapsibleSection"
import { Permissions } from "../../permissions"
import { Controller, UseFormReturn } from "react-hook-form";
import { ICreateOrgForm, IPermission } from "interfaces";
import { HttpError } from "@refinedev/core";

export const PermissionsSection = (props: UseFormReturn<ICreateOrgForm, HttpError, ICreateOrgForm>) => {
  const { control, resetField } = props;
  return (
    <CollapsibleSection label="Module access">
      <div className="px-4 py-6 sm:px-6">
        <Label 
          required
          id="access_permission" 
          name="Module access permission"
          hint="Initializing the permission list for the Workspace tool of each Organization."
        />
        <Controller
          control={control}
          name="permissions"
          render={({ field: { onChange, value, ref } }) => (
            <Permissions 
              formPermissionValue={value} 
              onChange={(data: IPermission[]) => onChange(data)}
              resetField={resetField}
            />
          )}
        />
      </div>
    </CollapsibleSection>

  )
}